/*
 * CUSTOM 2026-09-16 — Mindestverweildauer fuer den Bildwechsel auf Produktkarten.
 *
 * Problem: <secondary-media> (assets/theme.js) wechselt das Kartenbild bei JEDER Mausbewegung.
 * Beim Scrollen streift der Zeiger zwangslaeufig ueber viele Karten — alle springen gleichzeitig,
 * das Raster wirkt unruhig.
 *
 * Verhalten: Der Zeiger muss EINMALIG die eingestellte Zeit auf einer Karte verweilen. Danach
 * arbeitet das Theme unveraendert weiter — die Bilder folgen der Mausrichtung in alter
 * Geschwindigkeit. Erst beim Verlassen der Karte beginnt die Zeit wieder von vorn.
 *
 * Gemessen wird an der GANZEN KARTE (.product-card), nicht am Bildbereich. Titel und Preis liegen
 * ausserhalb von <secondary-media>, aber innerhalb der Karte: Wer dort misst, wertet jede Bewegung
 * ueber dem Titel als "Karte verlassen" und verlangt danach erneut die volle Wartezeit.
 *
 * Abgefangen wird auf dem DOKUMENT in der Capture-Phase. Grund: init() im Theme registriert den
 * Listener mit `this.addEventListener('mousemove', this.onMoveHandler)` — das kopiert die
 * Funktionsreferenz, ein spaeter ersetzter Prototyp wirkt fuer bereits initialisierte Karten nicht
 * mehr. Capture auf dem Dokument laeuft dagegen garantiert vor jedem Listener am Element.
 */
(() => {
  if (window.__customCardHoverDelay) return;
  window.__customCardHoverDelay = true;

  const script = document.currentScript;
  const delay = Math.max(0, parseInt(script?.dataset.delay ?? '750', 10) || 0);
  if (!delay) return;

  /* Welche Karte der Zeiger seit wann beruehrt. */
  let aktuelleKarte = null;
  let seit = 0;

  document.addEventListener('mousemove', (event) => {
    const ziel = event.target;
    if (!ziel || !ziel.closest) return;

    const karte = ziel.closest('.product-card');
    if (!karte) {
      aktuelleKarte = null;
      return;
    }

    /* Neue Karte: Zeit beginnt. Gleiche Karte: Zeit laeuft weiter — auch wenn der Zeiger
       gerade ueber Titel oder Preis steht. */
    if (karte !== aktuelleKarte) {
      aktuelleKarte = karte;
      seit = event.timeStamp;
    }

    /* Nur Bewegungen, die den Bildbereich betreffen, koennen einen Wechsel ausloesen. */
    if (!ziel.closest('secondary-media')) return;

    /* Wartezeit noch nicht erreicht: Ereignis stoppen, bevor es das Element erreicht. */
    if (event.timeStamp - seit < delay) {
      event.stopPropagation();
    }
  }, true);

  /* Zuruecksetzen nur beim echten Verlassen der Karte.
     mouseout feuert auch beim Wechsel zwischen Kindelementen INNERHALB der Karte — wer das nicht
     abfaengt, startet die Wartezeit staendig neu und verlangt sie vor jedem Bildwechsel erneut.
     relatedTarget ist das neu betretene Element; gehoert es noch zur Karte, passiert nichts.
     Das Zuruecksetzen auf das erste Bild macht weiterhin das Theme selbst. */
  document.addEventListener('mouseout', (event) => {
    const ziel = event.target;
    if (!ziel || !ziel.closest) return;

    const karte = ziel.closest('.product-card');
    if (!karte || karte !== aktuelleKarte) return;

    const neuesZiel = event.relatedTarget;
    if (neuesZiel && karte.contains(neuesZiel)) return;

    aktuelleKarte = null;
  }, true);
})();
